"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
function OtherMusclesItem({ onClick, onFade, name, isSelected = false, isFaded = false, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const [isFadedMusclese, setIsFadedMusclese] = (0, react_1.useState)(isFaded);
    const onHandleFade = () => {
        onFade();
        setIsFadedMusclese(!isFadedMusclese);
    };
    return ((0, jsx_runtime_1.jsxs)(StyledButton, { onClick: onClick, isSelected: isSelected, "data-e2e": 'OtherMusclesItem_StyledButton', children: [(0, jsx_runtime_1.jsx)(Text, { "data-e2e": 'OtherMusclesItem_Text', children: t(name) }), (0, jsx_runtime_1.jsx)(FadeButton, { selected: isFadedMusclese, "$visible": isSelected, onClick: onHandleFade, tabIndex: isSelected ? 0 : -1, "data-e2e": 'OtherMusclesItem_FadeButton', children: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.motion.fade) })] }));
}
exports.default = OtherMusclesItem;
const FadeButton = (0, styled_components_1.default)(ui_1.ToolBarBaseButton) `
  font-weight: ${({ selected }) => (selected ? 'bold' : 'normal')};
  font-size: 14px;
  text-transform: uppercase;

  visibility: ${({ $visible = true }) => ($visible ? 'visible' : 'hidden')};
`;
const Text = styled_components_1.default.div `
  font-size: 16px;
  width: 156px;
`;
const StyledButton = (0, styled_components_1.default)(ui_1.ToolBarBaseButton) `
  max-width: 242px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  text-align: left;

  ${({ isSelected }) => isSelected &&
    (0, styled_components_1.css) `
      font-weight: 700;
    `}

  &:hover ${FadeButton} {
    visibility: visible;
  }
`;
